import React from 'react';
import {
  AuthenticatedUser,
  useGlobalUser,
  useLoginModal,
} from '@sparknz/journeys-common';
import { Button } from '@sparknz/spark-pattern-library';
import { updateTrackedUser } from '@sparknz/tracking';

import { useIdentityAccountsQuery$data } from '__generated__/useIdentityAccountsQuery.graphql';
import { useProductDetails } from 'journey/productDetails/provider';
import { ProductDetailsActionTypes } from 'journey/productDetails/reducer/productDetails.reducer';
import {
  ActionLayerStatus,
  IfpEligibilityCheckSteps,
} from 'journey/productDetails/typings';

const { CheckEligibility, Login, AccountSelection } = IfpEligibilityCheckSteps;

interface IfpEligibilityCheckButtonProps {
  setActiveIfpCheckStep: (step: IfpEligibilityCheckSteps) => void;
  refetchAccountList: () => Promise<useIdentityAccountsQuery$data>;
  refetchLoginStatus: () => Promise<AuthenticatedUser>;
  disabled: boolean;
}

export default function IfpEligibilityCheckButton({
  refetchAccountList,
  refetchLoginStatus,
  setActiveIfpCheckStep,
  disabled,
}: IfpEligibilityCheckButtonProps) {
  const { dispatch } = useProductDetails();

  const { openLoginModal } = useLoginModal();
  const { refetchUser } = useGlobalUser();

  function handleLoginModalClose() {
    setActiveIfpCheckStep(CheckEligibility);
  }

  async function handleLoginSuccess() {
    await refetchLoginStatus();
    await refetchAccountList();
    refetchUser();
    updateTrackedUser();
    dispatch({
      type: ProductDetailsActionTypes.SetActionLayer,
      actionLayerStatus: ActionLayerStatus.ShowExistingPlan,
    });
    setActiveIfpCheckStep(AccountSelection);
  }

  function handleClick() {
    setActiveIfpCheckStep(Login);
    openLoginModal({
      onClose: handleLoginModalClose,
      onLoginSuccess: handleLoginSuccess,
    });
  }

  return (
    <Button variant="primary" onClick={handleClick} disabled={disabled}>
      Sign in to check eligibility
    </Button>
  );
}
